import { IDeviceList } from "types/IDeviceList"
import { protectedApi } from "../../Api/protectedAPI"
interface DevicePayload {
    deviceId: number[]
}

const deviceList = protectedApi.injectEndpoints({

    endpoints: (build) => ({
        deviceList: build.mutation<IDeviceList, Partial<DevicePayload>>({
            query: (data) => {
                return {
                    method: "GET",
                    providesTags: ["deviceList"],
                    url: `devices?deviceId=[${data.deviceId}]`,
                }
            },
        }),
    }),
})

export const { useDeviceListMutation } = deviceList


